import { CommonManipulator } from './Common/Common';
import { ApplyStylesManipulator } from './Common/Styles/ApplyStyles';
import { DocumentStylesManipulator } from './Common/Styles/DocumentStyles';
import { RemoveStylesManipulator } from './Common/Styles/RemoveStyles';
import { ContentManipulator } from './ContentManipulator';
import { InsertManipulator } from './Normal/Insert';
import { RemoveManipulator } from './Normal/Remove';
import { SplitManipulator } from './Normal/Split';

export class NormalManipulator extends ContentManipulator {
  manipulatorContext: Editor.Edition.ManipulatorsContext;

  constructor(ctx: Editor.Edition.Context) {
    super(ctx);

    this.manipulatorContext = {};

    this.manipulatorContext.common = new CommonManipulator(
      this.editionContext,
      this.manipulatorContext,
    );
    this.manipulatorContext.styles = {
      apply: new ApplyStylesManipulator(this.editionContext, this.manipulatorContext),
      remove: new RemoveStylesManipulator(this.editionContext, this.manipulatorContext),
    };
    this.manipulatorContext.docStyles = new DocumentStylesManipulator(
      this.editionContext,
      this.manipulatorContext,
    );
    this.manipulatorContext.insert = new InsertManipulator(
      this.editionContext,
      this.manipulatorContext,
    );
    this.manipulatorContext.remove = new RemoveManipulator(
      this.editionContext,
      this.manipulatorContext,
    );
    this.manipulatorContext.split = new SplitManipulator(
      this.editionContext,
      this.manipulatorContext,
    );
  }
}
